import type { FC } from 'react'
import { useMemo, useState } from 'react'
import type { Bet, DragItem, ProofPoint, Stage } from '../domain/Bet.domain'
import { useGetCategories } from '../repositories/useGetCategories'
import { BetCard } from './BetCard'

interface Props {
  bets: Bet[]
  onChangeProof: (
    betId: string,
    stage: Stage,
    proofId: string,
    updated: ProofPoint
  ) => void
  onMoveProof: (item: DragItem, toStage: Stage) => void
}

export const BoardView: FC<Props> = ({ bets, onChangeProof, onMoveProof }) => {
  const [view, setView] = useState<string>('all')
  const { data: categories = [] } = useGetCategories()

  const filterOptions = useMemo(
    () => [{ id: 'all', name: 'All' }, ...categories],
    [categories]
  )

  const [expanded, setExpanded] = useState<Set<string>>(
    () => new Set([bets[0]?.id ?? ''])
  )

  const toggle = (id: string) => {
    setExpanded((prev) => {
      const next = new Set(prev)
      next.has(id) ? next.delete(id) : next.add(id)
      return next
    })
  }

  const filtered =
    view === 'all' ? bets : bets.filter((b) => b.category.id === view)

  return (
    <>
      {/* Category filter */}
      <div style={{ display: 'flex', gap: 6, marginBottom: 16 }}>
        {filterOptions.map((v) => (
          <button
            key={v.id}
            onClick={() => setView(v.id)}
            style={{
              padding: '5px 14px',
              borderRadius: 20,
              border: '1px solid #e5e7eb',
              fontSize: 13,
              fontWeight: 500,
              cursor: 'pointer',
              background: view === v.id ? '#111827' : '#fff',
              color: view === v.id ? '#fff' : '#374151',
            }}
          >
            {v.name}
          </button>
        ))}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {filtered.map((bet) => (
          <BetCard
            key={bet.id}
            bet={bet}
            isOpen={expanded.has(bet.id)}
            onToggle={() => toggle(bet.id)}
            onChangeProof={(stage, proofId, updated) =>
              onChangeProof(bet.id, stage, proofId, updated)
            }
            onMoveProof={onMoveProof}
          />
        ))}
      </div>
    </>
  )
}
